module.exports = __webpack_public_path__ + "img/Map.9a1cdbd3.svg";